<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/products">Products</router-link></li>
        <li><router-link v-bind:to="`/products/${this.$route.params.product_id}`">{{ this.$store.state.product.name }}</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">Firmware updates</a></li>
      </ul>
    </nav>

    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="field">
            <p><router-link v-bind:to="`/products/${this.$route.params.product_id}/fw_updates/create`" class="button is-info">Upload new firmware</router-link></p>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p>Total: <strong>{{ this.$store.state.fwUpdatesTotal | numberDisplay }}</strong> firmware updates</p>
        </div>
      </div>
    </nav>

    <modal v-bind:visible="showModal" v-on:close="showModal = false">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="title is-4">Deleting firmware update</p>
        </header>
        <section class="modal-card-body">
          <div class="media">
            <div class="media-left">
              <span class="icon is-large has-text-danger"><i class="fa fa-3x fa-exclamation-triangle"></i></span>
            </div>
            <div class="media-content">
              <p>Are you sure you want to <strong>delete</strong> this firwmare update?</p>
              <p>This action cannot be undone.</p>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-danger" v-on:click="deleteItem(fwUpdateId)">Delete</button>
          <button class="button is-light" v-on:click="showModal = false">Cancel</button>
        </footer>
      </div>
    </modal>

    <pagination
      v-bind:urlBuilder="buildPaginatorUrls"
      v-bind:currentPage="currentPage"
      v-bind:lastPage="lastPage"
      v-bind:displayPage="5"
      class="is-small" />

    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>ID</th>
          <th>Filename</th>
          <th>Version</th>
          <th>Description</th>
          <th>Updated at</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!this.$store.state.fwUpdates.length">
          <td colspan="5" class="has-text-centered has-text-grey">No firmware updates found</td>
        </tr>
        <tr v-for="item in this.$store.state.fwUpdates">
          <td>{{ item.id }}</td>
          <td><a v-bind:href="`${apiUrl}/fw_updates/${item.filename}`">{{ item.filename }}</a></td>
          <td>{{ item.version }}</td>
          <td class="text-column">{{ item.description }}</td>
          <td>{{ item.updated_at }}</td>
          <td><a v-on:click="showModal = true; fwUpdateId = item.id" title="Delete firmware file"><span class="icon has-text-danger"><i class="fa fa-lg fa-trash"></i></span></a></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { Modal } from 'vue-bulma-modal'
  import Pagination from 'vue-bulma-pagination'

  export default {
    data () {
      return {
        showModal: false,
        apiUrl: process.env.API_URL,
        fwUpdateId: null
      }
    },

    computed: {
      currentPage () {
        return parseInt(this.$route.query.page) || 1
      },

      lastPage () {
        return Math.ceil(this.$store.state.fwUpdatesTotal / 20)
      }
    },

    methods: {
      buildPaginatorUrls (page) {
        return { query: { ...this.$route.query, page } }
      },

      deleteItem (fwUpdateId) {
        this.showModal = false

        this.$store.dispatch('deleteFwUpdate', fwUpdateId)
          .then(() => {
            this.$store.dispatch('getProductFwUpdates', {
              productId: this.$route.params.product_id,
              params: this.$route.query
            })
          })
          .catch(() => {
            // Show error bubble
            this.$store.commit('SHOW_ERROR_BUBBLE', true)
          })
      }
    },

    created () {
      this.$store.dispatch('getProduct', {
        productId: this.$route.params.product_id
      })

      this.$store.dispatch('getProductFwUpdates', {
        productId: this.$route.params.product_id,
        params: this.$route.query
      })
    },

    watch: {
      '$route.query' (query) {
        this.$store.dispatch('getProductFwUpdates', {
          productId: this.$route.params.product_id,
          params: this.$route.query
        })
      }
    },

    components: {
      Modal,
      Pagination
    }
  }
</script>

<style scoped>
  .text-column {
    white-space: pre-line;
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// FwUpdateList.vue?2d1edfea